<script lang="ts">
    import {_} from 'svelte-i18n'
    import Button, {Label} from '@smui/button';
    import {Icon} from '@smui/icon-button';
    import {soundPlayerState, soundsMode} from './services';
    import {SoundPlayerState, SoundsMode} from './sound/sound-types';

    function rotateSoundsMode() {
        if ($soundsMode === SoundsMode.ALL) {
            $soundsMode = SoundsMode.IMPORTANT;
        } else if ($soundsMode === SoundsMode.IMPORTANT) {
            $soundsMode = SoundsMode.NONE;
        } else {
            $soundsMode = SoundsMode.ALL;
        }
    }
</script>

<Button on:click={rotateSoundsMode} variant="unelevated">
    <Icon class="material-icons">
        {#if $soundPlayerState !== SoundPlayerState.PRELOADED} notifications_paused
        {:else if $soundsMode === SoundsMode.ALL} notifications
        {:else if $soundsMode === SoundsMode.IMPORTANT} notification_important
        {:else} notifications_off
        {/if}
    </Icon>
    <Label class="xs-hide">
        {#if $soundsMode === SoundsMode.ALL} {$_('settings.sounds.SoundsEnabled')}
        {:else if $soundsMode === SoundsMode.IMPORTANT} {$_('settings.sounds.ImportantOnly')}
        {:else} {$_('settings.sounds.SoundsDisabled')}
        {/if}
    </Label>
</Button>